import {
  packStringsForAPI,
  unpackStringsForUI,
} from '@/sections/insights/queryBuilder/entities/common/multiValueHelpers';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import { fetchAssetOrigins } from '@/sections/insights/queryBuilder/entities/utils/fieldValues';
import type { QueryFilter } from '@/types';

const operatorMap: Record<string, string> = {
  IN: 'contains',
};

const operatorMapInverse: Record<string, string> = {
  contains: 'IN',
};

/**
 * Reusable field definition for Asset origins
 * Dynamically fetches available origins from API
 */
export const AssetOrigins: SimpleFilterDefinition = {
  apiField: 'origins',
  uiField: 'Origins',
  inputType: 'dropdown',
  getAvailableValues: fetchAssetOrigins, // Fetches origins from statistics
  operators: ['contains', 'does not contain'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    const operator = getOperatorFromQueryFilter(queryFilter, operatorMap);
    const unpacked = unpackStringsForUI(queryFilter.value, operator);

    return {
      field: 'Origins',
      operator,
      value: unpacked,
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    const apiValue = packStringsForAPI(
      simpleFilter.value as string | string[],
      simpleFilter.operator
    );

    return {
      field: 'origins',
      operator: getOperatorFromSimpleFilter(simpleFilter, operatorMapInverse),
      value: apiValue,
      not: getNotFromSimpleFilter(simpleFilter),
      reverseOperands: true,
    };
  },
};
